
export const STATUS: any = {
    OPEN_FOR_BUSINESS_UNSPECIFIED: "",		
    OPEN: "Abierto",		
    CLOSED_PERMANENTLY: "Cerrado Permannentemente",		
    CLOSED_TEMPORARILY: "Cerrado Temporalmente",		    
};
